(() => {
  function boot(root) {
    if (root.dataset.nheReady) return;
    root.dataset.nheReady = 'true';
    const labels = JSON.parse(root.querySelector('[data-nhe-labels]').textContent);
    const cards = [...root.querySelectorAll('[data-nhe-card]')];
    const search = root.querySelector('[data-nhe-search]');
    const filters = [...root.querySelectorAll('[data-nhe-filter]')];
    const savedToggle = root.querySelector('[data-nhe-saved]');
    const status = root.querySelector('[data-nhe-status]');
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const key = 'nana-home-essentials-saved-v1';
    let saved = new Set(), category = 'all', savedOnly = false, storageFailed = false;
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      if (Array.isArray(value)) saved = new Set(value.filter(id => cards.some(card => card.dataset.nheId === id)));
    } catch { storageFailed = true; }
    const terms = new Map(cards.map(card => [card, normalize(card.textContent)]));
    function paintSaved() {
      cards.forEach(card => {
        const button = card.querySelector('[data-nhe-save]');
        const active = saved.has(card.dataset.nheId);
        button.setAttribute('aria-pressed', String(active));
        button.textContent = active ? labels.saved : labels.save;
      });
    }
    function filter() {
      const query = normalize(search.value.trim());
      let count = 0;
      cards.forEach(card => {
        const show = (category === 'all' || card.dataset.nheGroup === category) && (!savedOnly || saved.has(card.dataset.nheId)) && (!query || terms.get(card).includes(query));
        card.hidden = !show;
        if (show) count++;
      });
      status.textContent = count + ' ' + labels.results + (storageFailed ? '. ' + labels.storage_error : '');
      root.querySelector('[data-nhe-empty]').hidden = count !== 0;
    }
    filters.forEach(button => button.addEventListener('click', () => {
      category = button.dataset.nheFilter;
      filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      filter();
    }));
    savedToggle.addEventListener('click', () => {
      savedOnly = !savedOnly;
      savedToggle.setAttribute('aria-pressed', String(savedOnly));
      filter();
    });
    search.addEventListener('input', filter);
    cards.forEach(card => {
      card.querySelector('[data-nhe-save]').addEventListener('click', () => {
        const id = card.dataset.nheId;
        if (saved.has(id)) saved.delete(id); else saved.add(id);
        try { localStorage.setItem(key, JSON.stringify([...saved])); storageFailed = false; } catch { storageFailed = true; }
        paintSaved(); filter();
      });
      const printButton = card.querySelector('[data-nhe-print]');
      printButton.hidden = false;
      printButton.addEventListener('click', () => {
        const details = card.querySelector('.nhe-instructions');
        const wasOpen = details.open;
        const cleanup = () => {
          document.documentElement.classList.remove('nhe-print-mode');
          delete card.dataset.nhePrinting;
          details.open = wasOpen;
        };
        card.dataset.nhePrinting = 'true';
        details.open = true;
        document.documentElement.classList.add('nhe-print-mode');
        window.addEventListener('afterprint', cleanup, { once: true });
        try { window.print(); } catch { cleanup(); }
      });
      card.querySelector('[data-nhe-card-actions]').hidden = false;
    });
    function openHash() {
      const card = cards.find(item => '#' + item.id === location.hash);
      if (!card) return;
      category = 'all'; savedOnly = false; search.value = '';
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.nheFilter === 'all')));
      savedToggle.setAttribute('aria-pressed', 'false');
      filter();
      card.querySelector('.nhe-instructions').open = true;
      requestAnimationFrame(() => card.scrollIntoView({ block: 'start', behavior: 'instant' }));
    }
    window.addEventListener('hashchange', openHash);
    root.querySelector('[data-nhe-controls]').hidden = false;
    paintSaved(); filter(); openHash();
  }
  const start = () => document.querySelectorAll('[data-nana-essentials]').forEach(boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
